import type { ReactNode } from "react";

interface GateCardProps {
  title: string;
  children: ReactNode;
  /** Set on wide screens (a card that carries a form). */
  wide?: boolean;
}

/**
 * The single card shown before the console itself: sign in, wait, or stop.
 *
 * It names the product and the team, because it is the first thing a brand-new
 * person sees and it has to say where they are.
 *
 * Args:
 *     title: The card heading, rendered as the page's `h1`.
 *     children: Body of the card.
 *     wide: Roomier layout, for a card that carries a form.
 *
 * Returns:
 *     A centred card filling the viewport.
 */
export function GateCard({
  title,
  children,
  wide = false,
}: GateCardProps): JSX.Element {
  return (
    <main className="gate">
      <div className={`gate__card${wide ? " gate__card--wide" : ""}`}>
        <p className="gate__brand">
          <span className="eyebrow">Neuralk · Data Console</span>
        </p>
        <h1 className="gate__title">{title}</h1>
        {children}
      </div>
    </main>
  );
}
